import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import Container from "@scentregroup/ui/components/container";
import Heading from "@scentregroup/ui/components/heading";
import Paragraph from "@scentregroup/ui/components/paragraph";
import CardListV2 from '../card-list-v2';
import TabsHeaderV2 from '../tabs-v2/tabs-header-v2';
import { fromMovie } from '../card-list/card';
import { SEE_MORE_MOVIES_TEXT, MIN_MOVIES_TO_SHOW, MIN_MOVIES_TO_SHOW_V2 } from '../../constants';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

class FilteredCardList extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      activeTab: 0,
      minItems: this.context ? MIN_MOVIES_TO_SHOW_V2 : MIN_MOVIES_TO_SHOW
    });

    _defineProperty(this, "switchTabs", activeTabIndex => {
      this.setState({
        activeTab: activeTabIndex,
        minItems: null
      });
    });

    _defineProperty(this, "selectAllTab", () => {
      this.setState((_state, props) => ({
        activeTab: props.tabHeadings.map(heading => heading.displayDate).indexOf('All')
      }));
    });
  }

  getCardsForList() {
    const {
      tabHeadings,
      entries: movies,
      centreSlug
    } = this.props;
    const {
      activeTab
    } = this.state;
    const activeTabDate = tabHeadings[activeTab].date;
    return movies.filter(movie => activeTabDate === 'All' || movie.sessions.includes(activeTabDate)).map(fromMovie(centreSlug, activeTabDate !== 'All' && activeTabDate));
  }

  render() {
    const {
      tabHeadings,
      title
    } = this.props;
    const numberOfTabs = tabHeadings.length;
    const selectedTab = Math.min(numberOfTabs, this.state.activeTab);
    const headings = [...tabHeadings].splice(0, numberOfTabs);
    const unsuccessfulText = "We haven't confirmed movies for that day yet. How about trying another day?";
    const cardsForList = this.getCardsForList();
    return /*#__PURE__*/_jsxs(Container, {
      centred: true,
      type: "large",
      className: style.evolved,
      children: [/*#__PURE__*/_jsxs("div", {
        className: style.headings,
        children: [/*#__PURE__*/_jsx(Heading, {
          type: "large",
          className: style.title,
          children: title
        }), /*#__PURE__*/_jsx(TabsHeaderV2, {
          headings: headings.map(tabHeading => tabHeading.displayDate),
          selectedTab: selectedTab,
          onTabHeadingClick: this.switchTabs
        })]
      }), cardsForList.length > 0 && /*#__PURE__*/_jsx(CardListV2, {
        cards: cardsForList,
        buttonText: SEE_MORE_MOVIES_TEXT,
        minItems: this.state.minItems
      }), cardsForList.length === 0 && /*#__PURE__*/_jsxs("div", {
        className: style.unsuccessful,
        children: [/*#__PURE__*/_jsx(Paragraph, {
          type: "large",
          className: style.unsuccessfulText,
          children: unsuccessfulText
        }), /*#__PURE__*/_jsx("button", {
          className: style.callToActionLink,
          onClick: this.selectAllTab,
          children: SEE_MORE_MOVIES_TEXT
        })]
      })]
    });
  }

}

export default FilteredCardList;